module.exports = __webpack_public_path__ + "static/media/OCFL-Pages-Video.67f1fd74.mp4";